import React, { useState } from "react";
import axios from "axios";
const API = process.env.REACT_APP_API_URL || "https://prestijcrm.duckdns.org";
export default function Login({ setToken }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [hata, setHata] = useState("");
  const girisYap = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(API + "/api/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      setToken(res.data.token);
    } catch (err) {
      setHata(err.response?.data?.error || "Giriş başarısız");
    }
  };
  return (
    <div style={{background:"#0f172a",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"#1e293b",padding:"40px",borderRadius:"12px",width:"360px"}}>
        <h1 style={{color:"#3b82f6",marginBottom:"8px",fontSize:"24px"}}>Prestij Grup CRM</h1>
        <p style={{color:"#94a3b8",marginBottom:"24px"}}>Hesabınıza giriş yapın</p>
        {hata && <div style={{background:"#ef444433",color:"#f87171",padding:"10px",borderRadius:"6px",marginBottom:"16px"}}>{hata}</div>}
        <form onSubmit={girisYap}>
          <div style={{marginBottom:"16px"}}>
            <label style={{color:"#94a3b8",fontSize:"14px"}}>E-posta</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required
              style={{width:"100%",padding:"10px",marginTop:"6px",background:"#0f172a",border:"1px solid #334155",borderRadius:"6px",color:"white",boxSizing:"border-box"}} />
          </div>
          <div style={{marginBottom:"24px"}}>
            <label style={{color:"#94a3b8",fontSize:"14px"}}>Şifre</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required
              style={{width:"100%",padding:"10px",marginTop:"6px",background:"#0f172a",border:"1px solid #334155",borderRadius:"6px",color:"white",boxSizing:"border-box"}} />
          </div>
          <button type="submit" style={{width:"100%",padding:"12px",background:"#3b82f6",color:"white",border:"none",borderRadius:"6px",fontSize:"16px",cursor:"pointer",fontWeight:"600"}}>Giriş Yap</button>
        </form>
      </div>
    </div>
  );
}
